import request from '@/utils/request'

// export function login(username, password) {
//   return request({
//     url: '/userAdmin/login',
//     method: 'post',
//     data: {
//       username,
//       password,
//       platId:'6'
//     }
//   })
// }

export function login(username, password,loginType,userType) {
  return request({
    url: '/user/login1',
    method: 'post',
    data: {
      username,
      password,
      platId:'6',
      loginType,
      userType
    }
  })
}

export function logins(username, password, type) {
  return request({
    url: '/user/login',
    method: 'post',
    data: {
      username,
      password,
      type,
      platId:'6'
    }
  })
}

//根据手机号查询账户
export function getUserByPhone(params) {
  return request({
    url: '/user/getUserByPhone',
    method: 'get',
    params: params
  })
}

//获取用户信息及权限
export function getInfo() {
  return request({
    url: '/userAdmin/info',
    method: 'get',
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
  })
}

//获取会员信息
export function getInfos() {
  return request({
    url: '/user/info',
    method: 'get',
  })
}

export function menuInfo() {
  return request({
    url: '/new_menu/demo',
    method: 'get',
  })
}

//前台用户退出账号
export function logout_user() {
  return request({
    url: '/kxuser/user/logout',
    method: 'post'
  })
}

export function logout() {
  return request({
    url: '/kxuser/userAdmin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/kxuser/userAdmin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/kxuser/userAdmin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/kxuser/userAdmin/update/' + id,
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/kxuser/userAdmin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/kxuser/userAdmin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/kxuser/userAdmin/new_role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/kxuser/userAdmin/new_role/update',
    method: 'post',
    data: data
  })
}



//用户头像上传
export function uploadUserAvatar(data) {
  return request({
    url: '/kxuser/user/uploadUserAvatar/userAdmin',
    method: 'post',
    data: data,
    headers: {
      "Content-Type": "multipart/form-data;charset=utf-8"
    },
  })
}


//当前管理员信息
export function returnUserInfo(params) {
  return request({
    url: '/kxuser/userAdmin/returnUserInfo/',
    method: 'get',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js